import React, { useState, useRef, useEffect } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useMediaQuery } from '@mui/material';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState("0px");
  const contentRef = useRef(null);
  const isMobile = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    setMaxHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
  }, [isOpen]);

  const styles = {
    faqItem: {
      backgroundColor: "transparent",
      borderBottom: "1px solid #D5CDC8",
      marginBottom: "16px",
      overflow: "hidden",
    },
    questionContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      padding: isMobile ? "15px 0" : "20px 0",
    },
    question: {
      textAlign: "left",
      fontWeight: 600,
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.5,
      fontFamily: "Inter, sans-serif",
      color: "#2D669B",
      flex: 1, // Makes the text area flexible
    },
    iconContainer: {
      width: "30px",
      height: "30px",
      backgroundColor: "#2D669B",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0, // Prevents shrinking for consistent icon size
      marginLeft: "auto", // Pushes icon to the far right
    },
    icon: {
      color: "#F4E37B",
      fontSize: isMobile ? "16px" : "20px",
      transition: "transform 0.3s ease",
      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    },
    answerWrapper: {
      maxHeight: maxHeight,
      overflow: "hidden",
      transition: "max-height 0.4s ease",
    },
    answer: {
      padding: "0 0 16px 0",
      color: "#666666",
      fontSize: isMobile ? "14px" : "16px",
      lineHeight: 1.6,
      fontFamily: "poppins",
      textAlign: "justify",
      maxWidth: isMobile? "300px":"1121.81px",
    },
  };

  return (
    <div style={styles.faqItem}>
      <div style={styles.questionContainer} onClick={() => setIsOpen(!isOpen)}>
        <span style={styles.question}>{question}</span>
        <div style={styles.iconContainer}>
          <ExpandMoreIcon style={styles.icon} />
        </div>
      </div>
      <div ref={contentRef} style={styles.answerWrapper}>
        <div style={styles.answer}>{answer}</div>
      </div>
    </div>
  );
};

const FAQPersonal = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  const faqData = [
    {
      question: "What are your supported currencies?",
      answer: "We support a wide range of currencies, including USD, EUR, and many more.",
    },
    {
      question: "What are your supported networks?",
      answer: "Our platform supports various networks, such as Ethereum, Bitcoin, and more.",
    },
    {
      question: "What countries can you service?",
      answer: "We service a wide range of countries across the globe.",
    },
    {
      question: "Are there any minimums to open an OTC trade account?",
      answer: "The minimum transaction size for our OTC services typically starts at $50,000 per month. This threshold is in place to ensure the service remains focused on high-volume traders and institutional clients.",
    },
    {
      question: "How is OTC different from normal exchanges?",
      answer: "OTC trading deals with larger volume transactions when compared to exchanges and offering a personalized service to service your needs.",
    },
    {
      question: "Can I use Tennet OTC services for both buying and selling crypto?",
      answer: "Yes, Tennet OTC services cater to both buying and selling crypto. Our approach ensures you receive competitive rates whether you're looking to increase your crypto holdings or convert large amounts of crypto to fiat.",
    },
    {
      question: "Are there any hidden fees in Tennet OTC trades?",
      answer: "No, there are no hidden fees. We believe in complete transparency with our clients. All potential fees, including any transactional or service charges, are itemized on the trade interface before any trade is executed.",
    },
    {
      question: "How do I start using Tennet OTC services?",
      answer: "Begin by verifying your business with our KYB process. After approval, you can request for quote via our simple and easy-to-use trade interface.",
    },
    {
      question: "How long does a typical OTC trade take to settle?",
      answer: "Most OTC trades are settled within 1-2 working days they are initiated. The exact timing can depend on the complexity of the trade, the currencies involved, the verification of funds and the location of your bank. Our goal is to complete transactions as swiftly as possible, often within hours of fund verification.",
    },
  ];

  const styles = {
    faq: {
      backgroundColor: "#E0DCD9",
      color: "#333333",
      padding: isMobile ? "40px 20px" : "60px 40px",
      textAlign: "center",
      borderRadius: "8px",
    },
    title: {
      fontSize: isMobile ? '30px' : '40px',
      fontWeight: 'bold',
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      color: "transparent",
      textAlign: 'center',
      marginBottom: '40px',
    },
    faqList: {
      maxWidth: "1202px",
      minHeight: "98px",
      margin: "0 auto",
      textAlign: "left",
    },
  };

  return (
    <section style={styles.faq} id="faq">
      <h2 style={styles.title}>Frequently Asked Questions</h2>
      <div style={styles.faqList}>
        {faqData.map((item, index) => (
          <FAQItem key={index} question={item.question} answer={item.answer} />
        ))}
      </div>
    </section>
  );
};

export default FAQPersonal;
